<script setup lang="ts">
// TODO: migrate off deprecated package
import { useFlowControlStore } from '@components/flow-controller'
import { IconCheckupList, IconExclamationCircle } from '@tabler/icons-vue'
import { computed, watchEffect } from 'vue'

import StatusMessage from '@tix/ds/components/atoms/StatusMessage.vue'
import type { Schema } from '@tix/openapi-sdk'

import { errorTracker } from '@/services/errorTracking'

import SelectionSummary from '@/components/bundles/selections/SelectionSummary.vue'

import { useFlowSelections } from '@/composables/useFlowSelections'

import ActionHeader from './ActionHeader.vue'

const emit = defineEmits<{
  'go-to-step': [resolverId: string, type?: string]
}>()

const actionType: Schema<'action_confirm'>['type'] = 'confirm'

const store = useFlowControlStore()
const { rows, subtotal } = useFlowSelections()

const action = computed<Schema<'action_prompt_confirm'> | null>(
  () => (store.action?.type === actionType && store.action) || null,
)

store.registerInputGetter(() => {
  return action.value ? { isValid: true, input: {} } : { isValid: false }
})

watchEffect(() => {
  if (action.value && rows.value.length === 0) {
    errorTracker.track('No selections summary rows found on confirm step', { action: action.value })
  }
})

// TODO - Improve wording of user-facing error messaging - https://ticketure-team.atlassian.net/browse/TIC-5452
const errorMessage = computed<string | null>(() => {
  if (!action.value) return `Action is not a ${actionType} action`
  return null
})
</script>

<template>
  <div class="confirm-action">
    <template v-if="action">
      <ActionHeader
        :description="action.meta?.prompt"
        headingTag="h2"
        :icon="IconCheckupList"
        :title="action.meta?.summary_title"
      />

      <SelectionSummary
        :rows="rows"
        :subtotal="subtotal"
        @edit="(resolverId, type) => emit('go-to-step', resolverId, type)"
      />
    </template>

    <StatusMessage :icon="IconExclamationCircle" :message="errorMessage" variant="error" />
  </div>
</template>
